import { render, staticRenderFns } from "./RelatedItemsDropdown.vue?vue&type=template&id=28de7584&"
import script from "./RelatedItemsDropdown.vue?vue&type=script&lang=js&"
export * from "./RelatedItemsDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports